import { createAction, props } from '@ngrx/store';
import { Product } from '../../models/product';

export enum ProductsAction {
  SearchProducts = '[Products] Search Products',
  SearchProductsSuccess = '[Products] Search Products Success',
  SearchProductsFailure = '[Products] Search Products Failure',
  ClearProducts = '[Products] Clear Products',
}

export type SearchProductQuery = {
  s?: string;
  own?: boolean;
  supplierIds?: number[];
  ingredientId?: string;
}

export const searchProducts = createAction(
  ProductsAction.SearchProducts,
  props<SearchProductQuery>()
);

export const searchProductsSuccess = createAction(
  ProductsAction.SearchProductsSuccess,
  props<{ products: Product[] }>()
);

export const searchProductsError = createAction(
  ProductsAction.SearchProductsFailure,
  props<{ message: string }>()
);

export const clearProducts = createAction(
  ProductsAction.ClearProducts,
);
